let accessToken = null
async function doSomting() {
  const obj = JSON.parse(localStorage.getItem("authUser"))
  if (obj != undefined) {
    return (accessToken = obj.accessToken)
  }
}
doSomting().then()
export default accessToken
